<template>
    <div class="flex flex-grow flex-col items-center justify-center">
        <div class="text-center">
            <h1 class="text-warning-500 text-2xl font-medium">404</h1>
            <p class="py-2">
                <t path="navigation.errors.404" />
            </p>
            <div class="py-4">
                <v-button color="warning" size="xl" class="mr-1" @click="goBack"> ← <t path="navigation.errors.go_back" /> </v-button>
                <v-button :to="{ name: 'index' }" color="primary" size="xl">
                    <t path="navigation.errors.go_home" />
                </v-button>
            </div>
        </div>
    </div>

    <v-footer />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { goBackOr } from '~/helpers/navigation';

export default defineComponent({
    setup() {
        return {
            goBack: () => goBackOr(),
        };
    },
});
</script>
